<div class="card shadow-sm rounded-3">
  <div class="card-body">
    <div class="d-flex justify-content-between align-items-center">
      <h4 class="fw-bold text-dark m-0 d-flex align-items-center">
        <i class="las la-tachometer-alt me-2"></i> {{ 'PROPERTY.TAB.COUNTER' | translate }}
      </h4>
      <button (click)="onAdd()" class="btn btn-primary btn-sm py-2">
        <i class="las la-plus me-1"></i> {{ 'METER.ADD_COUNTER' | translate }}
      </button>
    </div>
    <p class="text-muted mt-2 mb-0">{{ 'PROPERTY.COUNTER_DESCRIPTION' | translate }}</p>
    <div class="mt-4">
      <p-table
        [hasList]="service.hasList"
        (delete)="onDelete($event)"
        (edit)="onEdit($event)"
        (onLazyLoad)="loadData($event)"
        (onPage)="pageChange($event)"
        (view)="onView($event)"
        [columns]="service.tableColumns"
        [dataKey]="'id'"
        [first]="first"
        [globalSearch]="globalSearch"
        [hasActions]="false"
        [hasAdd]="false"
        [hasDelete]="false"
        [hasEdit]="false"
        [hasView]="false"
        [loading]="loading()"
        [rows]="rows"
        [selectionMode]="'single'"
        [title]="service.title"
        [totalRecords]="total"
        [value]="list"
        paginatorPosition="bottom"
        tableStyleClass="table table-hover custom-table"
      >
        <ng-template #cells let-data>
          @for (col of service.tableColumns; track col) {
            <td>
                <span class="p-datatable-column-title">
                  @if (col.iconClass) {
                    <i [class]="col.iconClass"></i>
                  }
                  {{ (col.label ?? col.fieldName) | translate }}
                </span>
              @switch (col.fieldName) {
                @case ('actions') {
                  <div class="d-flex align-items-center gap-2">
                    <a
                      (click)="openReadings(data)"
                      ngbTooltip="{{ 'ACTIONS.READINGS' | translate }}"
                      class="btn btn-sm btn-outline-info d-flex align-items-center justify-content-center action-button">
                      <i class="las la-receipt fs-20"></i>
                    </a>
                    <a
                      (click)="openDetails(data)"
                      ngbTooltip="{{'INVOICES.DETAILS'|translate}}"
                      class="btn btn-sm btn-outline-primary d-flex align-items-center justify-content-center action-button">
                      <i class="las la-info-circle fs-20"></i>
                    </a>
                    <a
                      (click)="onEdit(data)"
                      ngbTooltip="{{ 'EDIT' | translate }}"
                      class="btn btn-sm btn-outline-primary d-flex align-items-center justify-content-center action-button">
                      <i class="las la-pen-fancy fs-20"></i>
                    </a>
                    <a
                      (click)="onDelete(data)"
                      ngbTooltip="{{ 'DELETE' | translate }}"
                      class="btn btn-sm btn-outline-danger d-flex align-items-center justify-content-center action-button">
                      <i class="las la-trash fs-20"></i>
                    </a>
                  </div>
                }
                @default {
                  <p-table-cell-value [data]="data" [column]="col"></p-table-cell-value>
                }
              }
            </td>
          }
        </ng-template>
      </p-table>
    </div>
  </div>
</div>
